import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey, State } from './configurator.reducer';
import { ConfiguratorIntegrations, ConfiguratorPartnership } from '@core/models';

export const selectConfiguratorState = createFeatureSelector<State>(featureKey);

export const getPartnership = createSelector(selectConfiguratorState, (state: State) => state.partnership);

export const getPartnershipDocument = createSelector(
  getPartnership,
  (state: ConfiguratorPartnership | null) => state?.partnershipDocument
);

export const getPartnershipUrl = createSelector(
  getPartnership,
  (state: ConfiguratorPartnership | null) => state?.partnershipUrl
);

export const getPartnershipImage = createSelector(
  getPartnership,
  (state: ConfiguratorPartnership | null) => state?.partnershipImage
);

export const getPartnershipName = createSelector(
  getPartnership,
  (state: ConfiguratorPartnership | null) => state?.partnershipName
);
